import { DownOutlined } from '@ant-design/icons';
import { Collapse, CollapseProps, Flex } from 'antd';
import './style.scss';

type AccordionProps = CollapseProps & {
  headerContent?: React.ReactNode;
  title?: React.ReactNode;
  className?: string;
  titleClassName?: string;
  children?: React.ReactNode;
  itemKey?: string;
  isActive?: boolean;
  iconPrefixContent?: React.ReactNode;
};

const Accordion = ({
  headerContent,
  title,
  children,
  titleClassName,
  itemKey,
  iconPrefixContent,
  isActive,
  ...props
}: AccordionProps) => {
  const titleClasses = `title ${titleClassName || ''}`;

  return (
    <Collapse
      bordered={false}
      items={[
        {
          key: itemKey || '1',
          id: '1',
          label: headerContent ? (
            <Flex vertical gap={3} className="header-space-container">
              <span className={titleClasses}>{title}</span>
              {headerContent}
            </Flex>
          ) : (
            title
          ),
          children: children,
        },
      ]}
      expandIcon={({ isActive }) => (
        <Flex gap={8} align="center">
          {iconPrefixContent}
          <DownOutlined rotate={isActive ? 180 : 0} />
        </Flex>
      )}
      expandIconPosition="end"
      {...props}
    />
  );
};

export default Accordion;
